import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_266: DocMigration = {
  maxSchemaVersion: "0.0.266",
  description: "Delete Foundation Datums from Foundation Catalog Settings",
  apply(json: any) {
    if (json.settings) {
      const newSettings = {};
      const newSettingsSets = {};

      const settingsToDelete: { [settingId: string]: string /* parentID */ } = {};
      let deleteSettings = true;

      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        const settingSet = json.settingsSets[setting.parentId];

        if (setting.type === "DATUM_CATALOG_SETTINGS") {
          settingsToDelete[settingId] = setting.parentId;
          continue;
        }

        if (!settingSet) {
          continue;
        }

        if (setting.type !== "FOUNDATION_CATALOG_SETTINGS") {
          continue;
        }

        if (!setting.foundationDatums) {
          // has already run the old version of migration 0_0_261
          deleteSettings = false;
          continue;
        }

        const datums = {};

        for (const datumId in setting.foundationDatums) {
          const datum = setting.foundationDatums[datumId];
          datums[datumId] = datum;
        }

        delete setting.foundationDatums;

        if (Object.keys(datums).length) {
          const settingsSetId = uid();
          const settingsSet = {
            entityType: "SETTINGS_SET",
            name: `Datums Setting Set from ${settingSet.name}`,
            id: settingsSetId,
            sortIndex: settingSet.sortIndex ?? 0,
            disabled: settingSet.disabled,
          };

          const datumSettingId = uid();
          const datumSettings = {
            id: datumSettingId,
            type: "DATUM_CATALOG_SETTINGS",
            entityType: "SETTINGS",
            name: "Datum Catalog Settings",
            sortIndex: setting.sortIndex ?? 0,
            parentId: settingsSetId,
            datums,
          };

          newSettings[datumSettingId] = datumSettings;
          newSettingsSets[settingsSetId] = settingsSet;
        }
      }

      if (!json.settingsSets) {
        json.settingsSets = {};
      }

      for (const settingSetId in newSettingsSets) {
        json.settingsSets[settingSetId] = newSettingsSets[settingSetId];
      }

      for (const settingId in newSettings) {
        json.settings[settingId] = newSettings[settingId];
      }

      if (deleteSettings) {
        for (const settingId in settingsToDelete) {
          delete json.settings[settingId];
          delete json.settingsSets[settingsToDelete[settingId]];
        }
      }
    }

    return json;
  },
};

export default migration_0_0_266;
